/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { RemoveItemsDto } from '../../models/remove-items-dto';

export interface FolderControllerMoveEntriesToAnotherFolder$Params {
  sourceFolderId: string;
  destinationFolderId: string;
      body: RemoveItemsDto
}

export function folderControllerMoveEntriesToAnotherFolder(http: HttpClient, rootUrl: string, params: FolderControllerMoveEntriesToAnotherFolder$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, folderControllerMoveEntriesToAnotherFolder.PATH, 'patch');
  if (params) {
    rb.path('sourceFolderId', params.sourceFolderId, {});
    rb.path('destinationFolderId', params.destinationFolderId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

folderControllerMoveEntriesToAnotherFolder.PATH = '/folder/moveEntries/{sourceFolderId}/{destinationFolderId}';
